import React from 'react';
import { ProductGrouping } from '../../../models/ProductGrouping';
import { Button } from '../../../common-components/Button/Button';
import { CardProductGroupTableHeader } from './CardProductGroupTableHeader';
import { CardProductGroupTableData } from './CardProductGroupTableData';
import { Card, Items, Options } from './styles';

interface ICardProductGroupProps {
  productGrouping?: ProductGrouping;
  remove?: (id: number) => void;
}

const CardProductGroup: React.FC<ICardProductGroupProps> = ({
  productGrouping,
  remove
}) => {

  return (
    <Card>
      <Items>
        <table>
          <thead>
            <CardProductGroupTableHeader />
          </thead>
          <tbody>
            {getItemListByType('óculos', productGrouping).map((item) => (<CardProductGroupTableData item={item}
              key={`product-grouping-${item.productGroupingId}-item-${item.id}`} data-key={`product-grouping-${item.productGroupingId}-item-${item.id}`} />))}
            {getItemListByType('lente', productGrouping).map((item) => (<CardProductGroupTableData item={item}
              key={`product-grouping-${item.productGroupingId}-item-${item.id}`} data-key={`product-grouping-${item.productGroupingId}-item-${item.id}`} />))}
          </tbody>
        </table>
      </Items>
      <Options>
        <Button text='Remover' type='danger' click={() => remove && productGrouping && remove(productGrouping.id)} />
      </Options>
    </Card>
  );

  function getItemListByType(type: string, groups?: ProductGrouping) {
    return groups?.productGroupingItems?.filter(pgi => pgi.orderItem.name.toLowerCase().includes(type)) || [];
  }
}

export { CardProductGroup };